import React, { useState } from 'react';

function CollapseButton(props) {

    function getClassName() {
        let classNames = props.className;
        if (!props.open) {
            classNames += " collapsed";
        }
        return classNames;
    }

    return (
        <button className={getClassName()} onClick={props.onClick} >{props.children}</button>
    );
}

export default CollapseButton;